module.exports = __webpack_public_path__ + "img/logo.fa9b53c1.svg";